import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { astriskStyle } from 'src/styles/CommonStyles.styled';
import {DARK_RED_FONT_COLOR, GRAY_FONT_COLOR, TITLE_FONT_COLOR, DARK_NAVY_FONT_COLOR, DARK_GRAY_FONT_COLOR, PRIMARY_FONT_COLOR, RED_FONT_COLOR, SMALL_TEXT_PX, BASE_TEXT_PX, SEMANTIC_TEXT_SMALL_PX, SEMANTIC_TEXT_PX, X_LARGE_TEXT_PX, SEMANTIC_TEXT_XSMALL_PX, FONT_FAMILY_DEMI, FONT_FAMILY_REGULAR, FONT_FAMILY_ITALIC, FONT_FAMILY_BOLD} from '../../../../styles/fonts/MCFontConstants';

export const Note = styled.div`
    width: ${({width}) => (width ? '50%' : '575px')};
    height: auto;
    flex:auto;
    text-align: left;
    letter-spacing: 0px;
    opacity: 1;
    margin-top: 5px;
    font-size: ${SMALL_TEXT_PX};
    margin-right: 75px;
    color: ${DARK_RED_FONT_COLOR};
    line-height: 19px;
    ${media.mediumDevice` 
        width:545px;
        margin-right:10px;
        margin-bottom: 10px;
    `};

    ${media.mobileDevice` 
margin-top:0px;     
width: 100%;
text-align: ${({textAlignMb}) => (textAlignMb ? textAlignMb : 'left')};
// padding:10px 19px;
margin-right:0px;
line-height:19px;
font-size: ${({ fontSize }) => (fontSize ? fontSize : SEMANTIC_TEXT_SMALL_PX)};
font-family: ${({ fontFamily }) => (fontFamily ? fontFamily : FONT_FAMILY_DEMI)};
color: ${({ color }) => (color ? color : DARK_RED_FONT_COLOR)};
`};
@media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
    margin-right: 0;
}
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    background: ${({ background }) => (background ? background : '#f5f5f5 0% 0% no-repeat padding-box')};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '10px')};
    padding: 6px 0;
    /* padding-top: 10px;
    padding-bottom: 25px; */
    padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '5px')};
    width: ${({ width }) => (width ? width : '100%')};
    height: ${({ height }) => (height ? height : '22px')};
    text-align: left;
    //font:15px Avenir Next World;
    letter-spacing: 0px;
    text-transform: uppercase;
    opacity: 1;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '15px'};
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : SEMANTIC_TEXT_SMALL_PX)};
    font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : '')};
    color: ${GRAY_FONT_COLOR};

    ${media.mobileDevice`
        margin-bottom:${({ mbMarginBottom }) => (mbMarginBottom ? mbMarginBottom : '15px')};
        /* padding-bottom: 30px; */
        padding: 0;
        // extra space removed b/w tissue service label and shipping details
        margin-top: 0px;
        // grey color applied from edge to edge
        height: ${({ mbHeight }) => mbHeight};
        
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '100%')};
        margin-left:${({ marginLeft }) => marginLeft && marginLeft};
        padding-left: ${({ mbPaddingLeft }) =>
            mbPaddingLeft ? mbPaddingLeft : '5px'};
        display: ${({ mbDisplay }) => (mbDisplay ? mbDisplay : 'flex')};
    `};
`;
export const HospitalName = styled(Header)`
    text-transform: none;
    display: block;
    color: ${DARK_NAVY_FONT_COLOR};
    padding-top: 5px;
    ${media.mobileDevice`
    display:none;
    `};
`;

export const ButtonContainer = styled.button`
    height: max-content;
    margin-left: 10px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: ${(isCondensedView) => isCondensedView ? '0px 0px 0px #1010EB' :'0px 0px 0px #00000029'};
    border: ${({ border }) => (border ? border : 'none')};
    border-radius: 29px;
    opacity: 1;
     width : auto;
     white-space :nowrap ;
    border: ${({ border }) => (border ? border : 'none')};
    cursor: pointer;
    visibility: ${(props) => props.visibility};
    ${media.mediumDevice` 
       // height:${({ iPadHeight }) => (iPadHeight ? iPadHeight : '65px')};
        width:${({ ipadWidth }) => (ipadWidth ? ipadWidth : '230px')};
    `};

    ${media.mobileDevice`
        /* width: 170px; */
        width: auto;
        height:${({ height }) => (height ? height : 'none')};
        padding-top:${({ padding }) => (padding ? padding : '4px')};
        margin: ${({ margin }) => (margin ? margin : '0px 4px 8px 4px')};
        white-space: normal;
        &.Button_createTemplate{
          //  width:49%;
        }
    `};
    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        width:${({ minDeviceWidth }) => (minDeviceWidth ? minDeviceWidth : '230px')};
     //   height:65px;
        white-space : nowrap;  
    
    }
    @media only screen and (max-device-width: 360px) {
        width:100% !important;
        margin: 0px 0px 8px 11px !important;
    }
    @media (min-width:1024px) and (max-width: 1200px) {
        width: auto;
        white-space : nowrap;  
    }
`;

export const ButtonContent = styled.div`
    display: flex;
    padding: ${(isCondensedView) => isCondensedView ? '8px' :'19px'};
    /* border: ${({ border }) => (border ? border : 'none')}; */
    align-items: center; 
    ${media.mobileDevice`
        margin:0px;
        padding: ${({isCondensedView, isLanguageChanged}) => 
            (isCondensedView || (!isLanguageChanged && !isCondensedView))? '8px 12px' :
            isLanguageChanged && !isCondensedView ? '8px 4px' :
            '19px'};
    `};
    @media (min-width: 900px) and (max-width: 1024px) {
        padding: ${(isCondensedView) => isCondensedView ? '7px 24px' :'4px'};
    } 
    @media (min-width: 768px) and (max-width: 900px) {
        padding: ${({ isCondensedView, isLanguageChanged }) => (isCondensedView && isLanguageChanged)?
                '5px':  (isCondensedView && !isLanguageChanged)? '7px 10px' :'4px'};
    }
    @media (min-width: 1024px) and (max-width: 1200px) {
        padding: ${({ isCondensedView, isLanguageChanged }) => (isCondensedView && isLanguageChanged)?
                '8px 20px':  (isCondensedView && !isLanguageChanged)? '7px 24px' :'10px'};
    } 
    @media only screen and (max-width: 380px) {
        padding: ${({isCondensedView, isLanguageChanged}) =>  
        (!isLanguageChanged && isCondensedView ) && '8px 4px'
        };
    } 
`;

export const Flex = styled.div`
    display: flex;
    margin: ${({ margin }) => (margin ? margin : '10px 0px 15px 0px')};
    justify-content: center;

    ${media.mobileDevice`
    margin: ${({ mbRemoveMargin, mbMargin }) => (mbRemoveMargin ? '0' : mbMargin ? mbMargin : '10px 10px')};
    margin-top: ${({ mbMarginTop }) => (mbMarginTop ? mbMarginTop : '')};
    //margin:0px;
    flex-wrap:wrap;
    justify-content: ${({ mbJustifyContent }) => (mbJustifyContent ? mbJustifyContent : '')};
    `}

    @media (max-width: 380px) {
        margin: ${({ mbMarginSE }) => (mbMarginSE ? mbMarginSE : '')};
    }
`;

export const Text1 = styled.div`
    margin: 0px 0px 0px 7px;
    text-align: left;
    letter-spacing: 0px;
    color: ${TITLE_FONT_COLOR};
    opacity: 1;
    line-height: 19px;

    ${media.mobileDevice`
margin:0px;
width: 110px;
white-space: nowrap;
height: auto;
padding-top:4px;
padding-left: 10px;
font-size: ${({ fontSize }) => (fontSize ? fontSize : SEMANTIC_TEXT_SMALL_PX)};
font-family: ${({ fontFamily }) => (fontFamily ? fontFamily : FONT_FAMILY_DEMI)};
color: ${({ color }) => (color ? color : TITLE_FONT_COLOR)};
    `};
    @media only screen and (max-device-width: 360px) {
        width: 100%;
        padding-top: 0px;
    }
`;
export const Text2 = styled.div`
    margin: 0px 0px 0px 10px;
    text-align: left;
    color: ${TITLE_FONT_COLOR};
    letter-spacing: 0px;
    opacity: 1;

    ${media.mobileDevice`
        margin:0px;
        padding-left: 10px;
        font-size: ${({ fontSize }) => (fontSize ? fontSize : SEMANTIC_TEXT_SMALL_PX)};
        font-family: ${({ fontFamily }) => (fontFamily ? fontFamily : FONT_FAMILY_DEMI)};
        color: ${({ color }) => (color ? color : TITLE_FONT_COLOR)};
    `};
    @media only screen and (max-device-width: 360px) {
        width: 100%;
        padding-top: 0px;
        height: auto;
    }
`;

export const SubText = styled.div`
    font-family: ${FONT_FAMILY_REGULAR};
    color: ${DARK_GRAY_FONT_COLOR};
    font-size: ${SEMANTIC_TEXT_PX};
`;

export const DetailsContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-bottom: ${({ setMarginBottom }) =>
        setMarginBottom ? '16px' : '0px'};
    ${media.mobileDevice`
    width: 100%;
`}
`;

export const Subtitle = styled.div`
    font-family: ${FONT_FAMILY_REGULAR};
    color: ${({ fontColor }) =>
    fontColor ? fontColor : DARK_GRAY_FONT_COLOR};
    font-size: ${SEMANTIC_TEXT_PX};
    font-size: ${({ fontSize }) =>
           fontSize ? fontSize : SEMANTIC_TEXT_PX};
    display: flex;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'row'};
    text-transform: ${({ textTransform }) =>
        textTransform ? textTransform : ''};
    background: ${({ setBackground }) => setBackground ? setBackground : ''};
    font-weight: ${({ setFontWeight }) => setFontWeight ? setFontWeight : ''};
    margin: ${({ setMargin }) => setMargin ? setMargin : ''};
    padding: ${({ setPadding }) => setPadding ? setPadding : ''};
    // address should come in 4 lines
    ${media.mobileDevice`
    width:${({ width }) => (width ? width : '')};
`}

    ${media.ipadAir`
    display: ${({ ipadDisplay }) =>
        ipadDisplay ? ipadDisplay : 'flex'};
    `};
`;

export const Title = styled.div`
    font-family: ${FONT_FAMILY_DEMI};
    color: ${DARK_GRAY_FONT_COLOR};
    font-size: ${SMALL_TEXT_PX};
    margin-bottom:${({ marginBottom }) =>
        marginBottom ? marginBottom : '8px'};

    ${astriskStyle};
    ${media.mobileDevice`
    margin-bottom:${({ marginBottom }) =>
        marginBottom ? marginBottom : '8px'};
`}
`;
export const MainContainerItems = styled.div`
    width: ${({ setWidth,isCondensedView }) =>
    setWidth ? setWidth : isCondensedView ? '33%' : '47%'};
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-bottom: ${({ setMarginBottom }) =>
        setMarginBottom ? '16px' : '0px'};
    margin-left: ${({ marginLeft }) =>
        marginLeft ? marginLeft : '0px'};
     word-break: ${({ wordBreak }) => wordBreak};

    ${media.mobileDevice`
        width: 100%;
        margin-bottom: ${({ mbMarginBottom }) => mbMarginBottom};
        margin-left: 0px;
    `}
`;
export const DetailsMainContainerBlock = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : 'space-between'};

    ${media.mobileDevice`
        width: 90%;
        margin: 0px auto;
        padding: ${({ mbPadding }) => (mbPadding ? mbPadding : ' ')};
        flex-direction: column;
    `}
`;

export const SetsItemsMainContainer = styled.div`
    ${media.mobileDevice`
        width: 100%;
     `}
`;

export const DetailsBlock = styled.div`
    display: flex;
    flex-wrap: wrap;
    ${media.mobileDevice`
        width: ${({ mbWidth }) => mbWidth};
        margin: ${({ mbMargin }) => mbMargin}
    `}
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 10px 10px 10px 0px;

    ${media.mobileDevice`
        margin:15px 0 0 0;
    `};
`;
export const Name = styled.div`
    margin: 5px 0px 0px 0px;
    text-align: left;
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : FONT_FAMILY_DEMI};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : BASE_TEXT_PX)};
    letter-spacing: -0.13px;
    color: ${GRAY_FONT_COLOR};

    ${media.mobileDevice`
        margin: ${({ mbMargin }) => (mbMargin ? mbMargin : '0px')};
        width: 100%;
        padding-left: 2px;
        font-size: ${({ mbfontSize }) => (mbfontSize ? mbfontSize : BASE_TEXT_PX)};
        font-family: ${({ mbfontFamily }) =>
            mbfontFamily ? mbfontFamily : FONT_FAMILY_REGULAR} ;
        letter-spacing: 0px;
    `};
`;
export const MainTextContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin: 10px 10px 10px 0px;
    width: 35%;
    justify-content: space-between;
    ${media.smalDevice`
        width: 45%;
    `}
    ${media.mobileDevice`
        margin:0px;
        width: 70%;
    `};
`;

export const CommonItems = styled.div`
    margin-top: ${({ hideMargin }) => (hideMargin ? '0px' : '20px')};
    padding: 0.5% 1% 0 0;
    display: flex;
    flex-direction: column;
    flex-basis: 33.33%;
    max-width: 340px;
    align-items: ${({ alignItemsStart }) => (alignItemsStart ? 'start' : '')};
    ${media.mediumDevice`
        flex-basis: 50%;
    `};
    ${media.mobileDevice`
        width: 90%;
        margin: 0 auto;
        flex-basis: 100%;
        
    `};
`;
export const CommonItemsContainer = styled.div`
    margin: 0px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    width: 100%;
    ${media.mobileDevice`
       flex-direction: column;
       width: 100%;
    `};
`;

export const PageLevelMessageContainer = styled.div`
    margin-top: 13px;
    margin-bottom: 20px;
    ${media.mobileDevice`
    `};
`;
export const SpecialHandlerMessage = styled.p`
    margin: ${({ margin }) => (margin ? margin : '0')};
    width: 70%;
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${SEMANTIC_TEXT_XSMALL_PX};
    line-height: 16px;
    letter-spacing: 0px;
    color: ${RED_FONT_COLOR};
    opacity: 1;
    ${media.mobileDevice`
        width: 100%;
    `}
`;

export const CartValidateContainer = styled.div`
    width: 100%;
    ${media.mobileDevice`
        width: 90%;
        margin: 0px auto 15px auto;
    `}
`;

export const AccountIdContainer = styled.span`
    font-family: ${FONT_FAMILY_ITALIC};
    font-size: ${SEMANTIC_TEXT_PX};
    margin: 0 0 0 5px;
    display: inline-block;
`;

export const AccountNameAndNumberContainer = styled.p`
    margin: 0px;
`;

export const NotesContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 10px 10px 10px 0px;
    width: 47%;

    ${media.mobileDevice`
        margin:15px 0 0 0;
        width: 100%;
    `};
`;
export const CartHeaderTitle = styled.div`
    font-family: ${FONT_FAMILY_DEMI};
    color: ${({ color }) => (color ? color : PRIMARY_FONT_COLOR)};
    height: 36px;
    width: ${({ width }) => (width ? width : '82px')};
    font-size: ${X_LARGE_TEXT_PX};
    // font-weight: 600;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-bottom: 6px;
    ${media.mobileDevice`
    font-family: ${({ fontFamily }) => (fontFamily ? fontFamily : FONT_FAMILY_DEMI)};
    color: ${({ color }) => (color ? color : DARK_GRAY_FONT_COLOR)};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : X_LARGE_TEXT_PX)};
     width: 300px;
      //margin-top: -19px;
       // padding-left: 15px;
        margin-top: -11px;
        margin-left: 10px;
    `}
`;
export const CartHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    // width: 1120px;
    // height: 36px;
    margin-top: 20px;
    // margin-bottom: 12px;
    ${media.mobileDevice`     
     margin-top: 0px;
    // margin-bottom: 18px;
     background: #ffffff 0% 0% no-repeat padding-box;
     box-shadow: 0px 0px 6px #00000029;
    `}
`;
export const CartActionItems = styled.div`
    font-family: ${FONT_FAMILY_BOLD};
    color: ${DARK_NAVY_FONT_COLOR};
    opacity: 1;
    display: flex;
    flex-direction: row;
    height: ${({ height }) => (height ? height : '20px')};
    width: ${({ width }) => (width ? width : '20%')};
    font-size: ${SEMANTIC_TEXT_SMALL_PX};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '20px')};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    cursor: ${({ setCursor }) => (setCursor ? setCursor : null)};
    ${media.mobileDevice`
    font-family: ${({ fontFamily }) => (fontFamily ? fontFamily : FONT_FAMILY_DEMI)};
    color: ${({ color }) => (color ? color : DARK_GRAY_FONT_COLOR)};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : X_LARGE_TEXT_PX)};
    width : 200px,
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : null)};       
    white-space: nowrap;
    margin-top: ${({ mbMarginTop }) => (mbMarginTop ? mbMarginTop : '0px')};
    `}
`;

export const AddIcon = styled.div`
    // display: ${({ display }) => (display ? display : 'contents')};
    // padding: ${({ padding }) => (padding ? padding : '0px 5px 2px')};
    float: ${({ float }) => (float ? float : 'right')};
    display: ${({ isReviewSubmitScreen, display }) =>
        isReviewSubmitScreen ? null : display ? display : 'contents'};
    padding: ${({ isReviewSubmitScreen, padding }) =>
        isReviewSubmitScreen ? null : padding ? padding : '0px 5px 2px'};
`;
